import { useQuery } from "react-query";
import { get, API_URL, APIResponse, APIError } from "../api";
import { useAuth } from "../context/AuthContext";

export const CREDIT_LIMIT_ELIGIBILITY_STATUS_KEY =
  "credit-limit-eligibility-status";

export interface CreditLimitEligibilityStatus {
  status: "none" | "pending" | "approved" | "declined";
  credit_limit: number | null;
  claimed?: boolean;
  claimed_at?: string | null;
  created_at?: string;
  reviewed_at?: string;
}

export function useCreditLimitEligibilityStatus() {
  const { user } = useAuth();
  const userId = user?.id;
  const { data, isLoading, isError, error, refetch } = useQuery<
    APIResponse<CreditLimitEligibilityStatus>,
    APIError
  >(
    [CREDIT_LIMIT_ELIGIBILITY_STATUS_KEY, userId],
    () =>
      get(`${API_URL}/account/user/eligibility/status`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    { enabled: !!userId }
  );

  return {
    creditLimitEligibilityStatus: data?.data,
    isLoading,
    isError,
    error,
    refetch,
  };
}

export default useCreditLimitEligibilityStatus;
